class BackgroundVideoLoader {
	constructor(apiHostname, clientId) {
		const defaultApiHostname = 'api.rtvslo.si';
		const defaultClientId = '82013fb3a531d5414f478747c1aca622';

		this.apiHostname = apiHostname || defaultApiHostname;
		this.clientId = clientId || defaultClientId;
		this.playerElement = document.createElement('div');
		this.playerElement.id = 'backgroundVideoPlayer';
		document.body.appendChild(this.playerElement);
	}

	async initPlayer(avaID) {
		return this.getDrm(Number(avaID))
				.then(response => this.getVideo(avaID, response.jwt))
				.then((data) => this.createJwInstance(data));
	}

	loadVideo(avaID) {
		var self = this;

		this.getDrm(Number(avaID))
			.then(response => this.getVideo(avaID, response.jwt))
			.then((data) => {
				
				if (!data.addaptiveMedia?.hls_sec && !data.mediaFiles?.[0].streams?.hls_sec ) return false;

				if (data.addaptiveMedia?.hls_sec) {
					self.jwInstance.load({
						file: data.addaptiveMedia.hls_sec,
						type: 'hls'
					})
				} else {
					self.jwInstance.load({
						file: data.mediaFiles[0].streams.hls_sec,
						type: 'hls'
					})
				}
			});
	}

	createJwInstance(data) {
		
		if (typeof jwplayer === 'function' && data?.addaptiveMedia?.hls_sec) {
				this.jwInstance = jwplayer(this.playerElement.id);

				const playlist = [{
					file: data.addaptiveMedia.hls_sec,
					type: 'hls'
				}];

				var isMuted = true;
				if ( window.__bgPlayerMuted == false ) isMuted = false;

				this.jwInstance.setup({
					playlist: playlist,
					width: '100%',
					mute: isMuted,
					primary: 'html5',
					aspectratio: '16:9',
					controls: false,
					autostart: false,
					repeat: true,
					hlsjsConfig: {
            liveSyncDuration: 30,
            debug: false
					}
				});

				var self = this;

				this.jwInstance.on('ready', function () {
					self.jwInstance.getContainer().addEventListener('click', function () {
						if (self.jwInstance.getState() === "playing") {
							self.jwInstance.pause();
						} else if (self.jwInstance.getState() === "paused") {
							self.jwInstance.play();
						}
					});
				});

				return this.jwInstance;
		}

		return false;
	}

	async getDrm(avaID) {
		return new Promise((resolve, reject) => {
			let retryCount = 0;
			const retry = () => {
				fetch(`https://${this.apiHostname}/ava/getRecordingDrm/${avaID}?client_id=${this.clientId}`)
					.then((response) => response.json())
					.then((data) => {
						if (data && data.response) {
							resolve(data.response);
						} else if (retryCount < 5) {
							setTimeout(retry, 3000);
							retryCount += 1;
						} else {
							reject('Failed to fetch recording');
						}
					})
					.catch((reason) => {
						console.log('Error fetching recording: ' + reason);
						if (retryCount < 5) {
							setTimeout(retry, 3000);
							retryCount += 1;
						} else {
							reject('Failed to fetch recording');
						}
					})
			}

			retry();
		});
	}

	async getVideo(avaID, jwt) {
		return new Promise((resolve, reject) => {
			let retryCount = 0;
			const retry = () => {
				fetch(`https://${this.apiHostname}/ava/getMedia/${avaID}?client_id=${this.clientId}&jwt=${jwt}`)
					.then((response) => response.json())
					.then((data) => {
						if (data && data.response) {
							resolve(data.response);
						} else if (retryCount < 5) {
							setTimeout(retry, 3000);
							retryCount += 1;
						} else {
							reject('Failed to fetch recording');
						}
					})
					.catch((reason) => {
						console.log('Error fetching recording: ' + reason);
						if (retryCount < 5) {
							setTimeout(retry, 3000);
							retryCount += 1;
						} else {
							reject('Failed to fetch recording');
						}
					})
			}

			retry();
		});
	}
}

/*
var backgroundVideoLoader = new BackgroundVideoLoader('api.rtvslo.si', '82013fb3a531d5414f478747c1aca622');
backgroundVideoLoader.initPlayer(175112196);
*/